import { useCallback, useRef, useState } from 'react'

import { RaidMarkerType } from 'app/frontend/types/custom/RaidMarker'

const useCastNoteDraft = () => {
  const [draft, setDraft] = useState('')
  const textareaRef = useRef<HTMLTextAreaElement>(null)

  const insertMarker = useCallback((marker: RaidMarkerType) => {
    const token = `{${marker}}`
    setDraft((current) => `${current}${current.length ? ' ' : ''}${token}`)
  }, [])

  return {
    draft,
    setDraft,
    textareaRef,
    insertMarker,
  }
}

export default useCastNoteDraft
